import { createApiClient } from '@/shared/api/createApiClient';

export const ceApiClient = createApiClient(
  'ce_auth_token',
  'ce_active_tenant_id',
);
